import { render, staticRenderFns } from "./Buyu.vue?vue&type=template&id=0fb40472&scoped=true&"
import script from "./Buyu.vue?vue&type=script&lang=js&"
export * from "./Buyu.vue?vue&type=script&lang=js&"
import style0 from "./Buyu.vue?vue&type=style&index=0&id=0fb40472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb40472",
  null
  
)

export default component.exports